import CloseOutlined from "@mui/icons-material/CloseOutlined"
import { Box, Drawer, Grid, IconButton, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"

import { useTranslation } from "react-i18next"
import { AppDispatch } from "../../../store"
import { RootState } from "../../../store/reducers"
import {
	closeDrawer,
	IUserEditState,
} from "../../../store/user/user-edit-slice"
import CreateForm from "./form"

const UserDrawer = () => {
	const dispatch = useDispatch<AppDispatch>()
	const { t } = useTranslation()
	const { isDrawerOpen, isEditMode, currentUser }: IUserEditState = useSelector(
		(state: RootState) => state.userEdit
	)

	const handleClose = () => {
		dispatch(closeDrawer())
	}

	return (
		<Drawer anchor="right" open={isDrawerOpen} onClose={handleClose}>
			<Grid p={2} container justifyContent={"space-between"}>
				<Grid item flexGrow={1}>
					<Typography component="span" variant="h6">
						{isEditMode
							? `${t("form.header.modify.title", { ns: "user" })} ${currentUser?.fullName}`
							: t("form.header.create.title", { ns: "user" })}
					</Typography>
				</Grid>
				<Grid item>
					<IconButton
						onClick={() => handleClose()}
						sx={{ width: "30px", height: "30px" }}
					>
						<CloseOutlined />
					</IconButton>
				</Grid>
			</Grid>
			<Box p={2} sx={{ minWidth: "360px", width: "45vw" }}>
				<CreateForm
					isEditMode={isEditMode}
					onClose={handleClose}
					user={currentUser}
				/>
			</Box>
		</Drawer>
	)
}

export default UserDrawer
